(function () {
    const BREAKPOINT = 1280;
    const CLOSE_DELAY = 500;

    const items = document.querySelectorAll('.nav-item.dropdown');
    let closeTimer = null;
    let activeItem = null;

    function isDesktop() {
        return window.innerWidth >= BREAKPOINT;
    }

    const openDropdown = (item, focusFirstLink = false) => {
        clearTimeout(closeTimer);
        if (activeItem && activeItem !== item) {
            closeDropdown(activeItem);
        }
        activeItem = item;
        const toggle = item.querySelector('.dropdown-toggle');
        const menu = item.querySelector('.dropdown-menu');

        toggle?.setAttribute('aria-expanded', 'true');
        toggle?.classList.add('show');
        menu?.classList.add('show');

        if (focusFirstLink) {
            window.requestAnimationFrame(() => {
                const firstLink = menu?.querySelector('a[href], button');
                firstLink?.focus();
            });
        }
    };

    const closeDropdown = (item) => {
        if (!item) return;
        const toggle = item.querySelector('.dropdown-toggle');
        const menu = item.querySelector('.dropdown-menu');

        toggle?.setAttribute('aria-expanded', 'false');
        toggle?.classList.remove('show');
        menu?.classList.remove('show');
    };

    const closeActive = (immediate = false, blurToggle = true) => {
        if (!activeItem) return;
        clearTimeout(closeTimer);

        const currentItem = activeItem;
        const toggle = currentItem.querySelector('.dropdown-toggle');

        const doClose = () => {
            closeDropdown(currentItem);
            if (blurToggle && toggle) {
                toggle.blur();
            }
            if (activeItem === currentItem) {
                activeItem = null;
            }
        };

        if (immediate) {
            doClose();
        } else {
            closeTimer = setTimeout(doClose, CLOSE_DELAY);
        }
    };

    // Globální kliknutí myší mimo otevřený dropdown ho ihned zavře a rozostří toggle
    document.addEventListener('pointerdown', (e) => {
        if (!isDesktop() || !activeItem) return;

        if (!activeItem.contains(e.target)) {
            closeActive(true, true);
        }
    });

    items.forEach((item) => {
        const toggle = item.querySelector('.dropdown-toggle');
        const menu = item.querySelector('.dropdown-menu');

        // Odstraníme Bootstrap data atributy a případnou existující instanci na desktopu,
        // abychom měli plnou a čistou kontrolu nad stavem a focus managementem
        if (toggle) {
            toggle.removeAttribute('data-bs-toggle');
            toggle.removeAttribute('data-bs-auto-close');

            if (window.bootstrap?.Dropdown) {
                bootstrap.Dropdown.getInstance(toggle)?.dispose();
            }

            // Klik na toggle (myš nebo klávesnice Enter / Mezerník)
            toggle.addEventListener('click', (e) => {
                if (!isDesktop()) return; // mobilní zobrazení řeší mobile-menu.js
                e.preventDefault();

                // Pokud byl klik vyvolán myší (detail > 0), rozostříme, aby nevznikal focus ring
                if (e.detail > 0) {
                    toggle.blur();
                }

                if (activeItem === item) {
                    closeActive(true, true);
                } else {
                    openDropdown(item, false);
                }
            });

            // Klávesa ArrowDown na toggle otevře menu a přesune focus na 1. odkaz
            toggle.addEventListener('keydown', (e) => {
                if (!isDesktop()) return;

                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    openDropdown(item, true);
                }
            });
        }

        // Klávesa Escape uvnitř celého dropdownu zavře menu a vrátí focus na toggle
        item.addEventListener('keydown', (e) => {
            if (!isDesktop()) return;

            if (e.key === 'Escape' && activeItem === item) {
                e.preventDefault();
                closeActive(true, false);
                toggle?.focus();
            }
        });

        // Zavření při opuštění focusu z dropdownu klávesnicí (Tabem pryč na jiný prvek na stránce)
        item.addEventListener('focusout', (e) => {
            if (!isDesktop()) return;

            // Pokud nový aktivní prvek není uvnitř aktuálního dropdownu, zavřeme ho
            // ale NEBLURUJEME aktivní prvek (focus se má plynule přesunout na nový prvek)
            if (activeItem === item && (!e.relatedTarget || !item.contains(e.relatedTarget))) {
                closeActive(true, false);
            }
        });

        // Myš / Hover ovládání (pouze na hover zařízeních)
        if (window.matchMedia('(hover: hover)').matches) {
            item.addEventListener('mouseenter', () => {
                if (!isDesktop()) return;
                openDropdown(item, false);
            });

            item.addEventListener('mouseleave', () => {
                if (!isDesktop()) return;
                closeActive(false, true);
            });

            menu?.addEventListener('mouseenter', () => {
                if (!isDesktop()) return;
                clearTimeout(closeTimer);
            });

            menu?.addEventListener('mouseleave', () => {
                if (!isDesktop()) return;
                closeActive(false, true);
            });
        }
    });
})();